/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {FileSummaryModel} from '../../../api/ms-filemanager/contracts/file-summary.model';
import {WarningsEnum} from '../../../shared/warnings/warnings.enum';
import {FileDownloadHelperService} from '../../services/file-download/file-download-helper.service';
import {AttachmentListSummaryModel} from './attachment-list-summary.model';

@Component({
    selector: 'app-attachments-list-display',
    templateUrl: './attachments-list-display.component.html',
    styleUrls: ['./attachments-list-display.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AttachmentsListDisplayComponent implements OnChanges {

    @Input() attachments: FileSummaryModel[];
    @Input() directory: string;
    @Input() requiredAttachments: boolean;
    WarningsEnum = WarningsEnum;

    public attachmentsList: AttachmentListSummaryModel[];

    constructor(private fileDownloadHelperService: FileDownloadHelperService) {
    }

    mapFileSummaryArray(attachments: FileSummaryModel[]): void {
        this.attachmentsList = attachments.map((attachment) => ({
                file: attachment,
                isDownloading: false
            }));
    }

    downloadFile(fileName: string): void {
        this.manageFileDownloadStatus(fileName);
        this.fileDownloadHelperService.downloadFile(this.directory, fileName);
    }

    manageFileDownloadStatus(fileName: string): void {
        this.attachmentsList.find(item => item.file.name === fileName).isDownloading = true;
        this.fileDownloadHelperService.downloadIsOver.subscribe(status => {
            this.attachmentsList.find(item => item.file.name === status.fileName).isDownloading = !status.downloadIsOver;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['attachments']) {
            if (changes['attachments'].currentValue != null) {
                this.mapFileSummaryArray(this.attachments);
            }

        }
    }


}
